const CMS_BASE_URL = "https://api.dev.auxo.dk/public";

/**
 * Fetch a CMS collection list using the v2 endpoint.
 * Returns array of items.
 */
export async function fetchCmsCollection(collectionName) {
  try {
    const res = await fetch(`${CMS_BASE_URL}/v2/content/${collectionName}`);
    if (!res.ok) {
      // Fallback to plain array endpoint
      const fallbackRes = await fetch(`${CMS_BASE_URL}/content/${collectionName}`);
      if (!fallbackRes.ok) return [];
      const data = await fallbackRes.json();
      return Array.isArray(data) ? data : [];
    }
    const data = await res.json();
    return data.items || (Array.isArray(data) ? data : []);
  } catch (err) {
    console.error(`Fejl ved hentning af CMS samling ${collectionName}:`, err);
    return [];
  }
}

/**
 * Fetch a single entry by slug from CMS.
 */
export async function fetchCmsBySlug(slug) {
  try {
    const res = await fetch(`${CMS_BASE_URL}/by-slug/${encodeURIComponent(slug)}`);
    if (!res.ok) return null;
    return await res.json();
  } catch (err) {
    console.error(`Fejl ved hentning af CMS slug ${slug}:`, err);
    return null;
  }
}
